import { useState } from 'react'
import PropTypes from 'prop-types'

import CancelShippingModalView from './View'

const CancelShippingModal = ({
  shippings,
  abortCancellation,
  confirmCancellation,
}) => {
  const [hasFailed, setHasFailed] = useState(false)
  const [isCancelling, setIsCancelling] = useState(false)

  return (
    <CancelShippingModalView
      shippings={shippings.map(shippingInfo => ({
        shippingNumber: shippingInfo.shippingCode,
        senderCity: shippingInfo.senderAddress2,
        destinationCity: shippingInfo.recipientAddress2,
        recipientName: shippingInfo.recipientName,
      }))}
      isCancelling={isCancelling}
      hasError={hasFailed}
      cancel={abortCancellation}
      confirm={() => {
        setHasFailed(false)
        setIsCancelling(true)

        return confirmCancellation()
          .catch(() => {
            setHasFailed(true)
          })
          .finally(() => {
            setIsCancelling(false)
          })
      }}
    />
  )
}
CancelShippingModal.propTypes = {
  shippings: PropTypes.arrayOf(
    PropTypes.shape({
      shippingCode: PropTypes.string,
      senderAddress2: PropTypes.string,
      recipientName: PropTypes.string,
      recipientAddress2: PropTypes.string,
    }),
  ),
  abortCancellation: CancelShippingModalView.propTypes.cancel,
  confirmCancellation: CancelShippingModalView.propTypes.confirm,
}

export default CancelShippingModal
